module.exports = __webpack_public_path__ + "static/media/band.b97fd98b.mp3";